import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { memo } from 'react';

/** A viz naming a column its result does not have. */
export const BiVizMismatch = memo(() => (
  <CardNotice tone="danger" text="这张图表的数据不完整，请重新提问生成。" />
));
